import Vue from "vue";
import Hotjar from 'vue-hotjar';

if (!process.env.DEBUG) {
  Vue.use(Hotjar, { id: process.env.HOTJAR_ID });
}